const admins = [
    "shivamk2021@email.iimcal.ac.in",
    "prepcomm@email.iimcal.ac.in",
    "srilekha2022@email.iimcal.ac.in",
    "abhigna2022@email.iimcal.ac.in",
    "mayukh2022@email.iimcal.ac.in",
    "isgcore@email.iimcal.ac.in",
    "isg@email.iimcal.ac.in",
    "krithika2022@email.iimcal.ac.in",
    "naveenc2022@email.iimcal.ac.in"
]
export default admins;